<template>
    <v-chip
        closable 
        class="chip-base" 
        :color="color"
        @click:close="handleClose">
        {{ group }}: {{ label }}
    </v-chip>
</template>

<script>
export default {
    name: 'ChipBase',
    props: {
        color: {
            type: String,
            default: 'primary'
        },
        group: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        }
    },
    emits: ['close'],
    methods: {
        handleClose() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.chip-base {
    padding: 4px;
    padding-left: 16px;
    padding-right: 16px;
    border-radius: 8px;
    color: rgb(var(--v-theme-primary));
}
</style>